export default "__VITE_ASSET__vHqbSuqU__"